import axiosInstance from './axios/axiosConfig'
import { endpoints } from './axios/endpoints'

// The counts (Home's Pipelines card, the Pipelines list's total) show their
// own loading and error states: no loader and no toast.
const QUIET = { silentToast: true, silentErrorToast: true, background: true }

const HomeService = {
    /**
     * How many pipelines have `status` (GET /comms/v2/pipelines/count, a
     * count-only query on the list route's index, so the number matches the
     * Pipelines list without reading every page and its templates).
     *
     * @param {'active'|'inactive'} status
     * @returns {Promise<{count: number, complete: boolean}>} complete is
     *     always true: the API counts every page itself
     */
    pipelineCount: async (status) => {
        const resp = await axiosInstance.get(endpoints.countPipelines, {
            params: { status },
            ...QUIET,
        })
        const count = resp?.data?.count
        if (!Number.isInteger(count)) throw new Error('No count in the answer')
        return { count, complete: true }
    },

    /** How many pipelines are active (Home's Pipelines card). */
    activePipelineCount: () => HomeService.pipelineCount('active'),
}

export default HomeService
